import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["page", "label", "isActive", "isDisabled", "onClick"];
import * as React from 'react';
import cn from 'classnames';
import { min, max, clamp } from 'lodash-es';
import { safeInvoke, ControlShapeType, controlClasses } from '../../../library';
import { IconChevronLeft, IconChevronRight } from '../../../icons';
import { Button, Buttons } from '../../button';
export var paginationClasses = {
  MAIN: 'pagination',
  ARROW: 'pagination__arrow'
};
export var Paginator = function Paginator(props) {
  var _min;
  var showCount = (_min = min([props.showCount, props.totalPages])) !== null && _min !== void 0 ? _min : 0;
  var curPage = clamp(props.currentPage, 1, props.totalPages);
  var handleLinkClick = function handleLinkClick(page, e) {
    e.preventDefault();
    safeInvoke(props.onNavigate, page);
  };
  var jumpToFirst = function jumpToFirst() {
    safeInvoke(props.onNavigate, 1);
  };
  var jumpToLast = function jumpToLast() {
    safeInvoke(props.onNavigate, props.totalPages);
  };
  var renderlinks = function renderlinks() {
    var _max;
    var start = (_max = max([curPage - Math.floor(showCount / 2), 1])) !== null && _max !== void 0 ? _max : 0;
    var end = start + (showCount - 1);
    var items = [];
    if (end >= props.totalPages) {
      start = props.totalPages - showCount + 1;
      end = props.totalPages;
    }
    for (var i = start; i <= end; i++) {
      if (i === end && end < props.totalPages) {
        items.push(React.createElement(PageLink, {
          key: "jump",
          page: clamp(end + Math.floor(showCount / 2), props.totalPages),
          label: '...',
          size: props.size,
          shape: props.shape,
          density: props.density,
          onClick: handleLinkClick,
          isDisabled: props.isDisabled
        }));
      } else {
        items.push(React.createElement(PageLink, {
          key: i,
          page: i,
          label: i,
          isActive: curPage === i,
          size: props.size,
          shape: props.shape,
          density: props.density,
          onClick: handleLinkClick,
          isDisabled: props.isDisabled
        }));
      }
    }
    return items;
  };
  return React.createElement("div", {
    className: cn('pagination', props.className)
  }, React.createElement(PaginateArrow, {
    page: curPage - 1,
    isDisabled: props.isDisabled || curPage === 1,
    label: React.createElement(IconChevronLeft, null),
    size: props.size,
    onClick: handleLinkClick,
    onLongPress: jumpToFirst
  }), React.createElement(Buttons, null, renderlinks()), React.createElement(PaginateArrow, {
    page: curPage + 1,
    isDisabled: props.isDisabled || curPage === props.totalPages,
    label: React.createElement(IconChevronRight, null),
    size: props.size,
    onClick: handleLinkClick,
    onLongPress: jumpToLast
  }));
};
Paginator.defaultProps = {
  currentPage: 1,
  totalPages: 1,
  showCount: 5,
  shape: ControlShapeType.ROUNDED
};
var PageLink = function PageLink(props) {
  var page = props.page,
    label = props.label,
    _props$isActive = props.isActive,
    isActive = _props$isActive === void 0 ? false : _props$isActive,
    _props$isDisabled = props.isDisabled,
    isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled,
    onClick = props.onClick,
    controlProps = _objectWithoutProperties(props, _excluded);
  var derivedlabel = label !== undefined ? label : page;
  var handleClick = function handleClick(e) {
    safeInvoke(props.onClick, props.page, e);
  };
  return React.createElement(Button, _extends({
    intent: isActive ? 'primary' : 'none',
    appearance: isActive ? 'fill' : 'minimal',
    isDisabled: isDisabled,
    onClick: handleClick
  }, controlProps, {
    label: derivedlabel
  }));
};
export var PaginateArrow = function PaginateArrow(props) {
  var _React$useState = React.useState(),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    longPressTimeout = _React$useState2[0],
    setLongPressTimeout = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isLongPressed = _React$useState4[0],
    setIsLongPressed = _React$useState4[1];
  var handleClick = function handleClick(e) {
    safeInvoke(props.onClick, props.page, e);
  };
  var handleLongPress = function handleLongPress() {
    setIsLongPressed(true);
    window.setTimeout(function () {
      setIsLongPressed(false);
    }, 100);
    safeInvoke(props.onLongPress, props.page);
  };
  var handleMouseDown = function handleMouseDown(e) {
    var LONGPRESS_DELAY = 500;
    var longpress = window.setTimeout(handleLongPress, LONGPRESS_DELAY);
    setLongPressTimeout(longpress);
  };
  var handleMouseUp = function handleMouseUp(e) {
    window.clearTimeout(longPressTimeout);
  };
  var handleMouseOut = function handleMouseOut(e) {
    window.clearTimeout(longPressTimeout);
  };
  React.useEffect(function () {
    return window.clearTimeout(longPressTimeout);
  }, []);
  var classNames = cn(paginationClasses.ARROW, controlClasses({
    size: props.size,
    shape: 'circular'
  }), {
    '-disabled': props.isDisabled
  }, {
    '-active': isLongPressed
  });
  return React.createElement("button", {
    className: classNames,
    disabled: props.isDisabled,
    onClick: handleClick,
    onMouseDown: handleMouseDown,
    onMouseUp: handleMouseUp,
    onMouseOut: handleMouseOut
  }, props.label);
};